import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import { InjectedFormikProps, withFormik } from 'formik'

import Button        from '@material-ui/core/Button'
import Dialog        from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle   from '@material-ui/core/DialogTitle'

import { Communication }                                  from '../../redux/ducks'
import { EnhancedTextField, InlineError, LoadingOverlay } from '../atoms'
import {
  genValueMapper,
  mapFormikToMuiProps,
  proxyFormikSubmission,
}                                                         from './form-utils'
import {
  emptyTripartitaTeacherInitial,
  tripartitaTeacherInitialSchema,
  TripartitaTeacherInitialValues,
}                                                         from './schemas/tripartita.schema'

interface TripartitaInitialTeacherFormProps extends Communication {
  isOpen: boolean
  close: () => void
  onSubmit: (values: TripartitaTeacherInitialValues) => void
}

type Props = InjectedFormikProps<TripartitaInitialTeacherFormProps, TripartitaTeacherInitialValues>

const TripartitaTeacherInitialForm = (props: Props) => {
  const {
    isOpen,
    submitForm,
    close,
    fetching,
    error,
  } = props

  const mapper = mapFormikToMuiProps(props)

  return (
    <LoadingOverlay show={fetching}>
      <Dialog fullWidth open={isOpen}>
        <DialogTitle>
          Initial Tripartita Details
        </DialogTitle>
        <DialogContent>
          <EnhancedTextField
            fullWidth
            margin={'dense'}
            {...mapper('challenge')}
          />
          <EnhancedTextField
            fullWidth
            margin={'dense'}
            {...mapper('objectives')}
          />
        </DialogContent>
        {error && (
          <DialogContent>
            <InlineError i18nErrorId={error} />
          </DialogContent>
        )}
        <DialogActions>
          <Button color={'primary'} onClick={close}>
            <FormattedMessage id={'buttonActions.cancel'} />
          </Button>
          <Button color={'primary'} onClick={submitForm}>
            <FormattedMessage id={'buttonActions.save'} />
          </Button>
        </DialogActions>
      </Dialog>
    </LoadingOverlay>
  )
}

export default withFormik<TripartitaInitialTeacherFormProps, TripartitaTeacherInitialValues>({
  validationSchema: tripartitaTeacherInitialSchema,
  mapPropsToValues: genValueMapper(emptyTripartitaTeacherInitial),
  handleSubmit:     proxyFormikSubmission,
})(TripartitaTeacherInitialForm)



// WEBPACK FOOTER //
// ./src/components/forms/TripartitaTeacherInitialForm.tsx